import React, { FC } from 'react';
import styled from 'styled-components';

interface SwitchProps {
    name?: string;
    value: boolean;
    // eslint-disable-next-line no-unused-vars
    onChange: (value: boolean, name: string | undefined) => void;
}

const Switch: FC<SwitchProps> = ({ name, value, onChange }) => {
    const handleChange = () => {
        onChange(!value, name);
    };
    return (
        <CheckBoxWrapper>
            <CheckBox
                checked={value}
                onChange={handleChange}
                name={name}
                id="checkbox"
                type="checkbox"
            />
            <CheckBoxLabel htmlFor="checkbox" />
        </CheckBoxWrapper>
    );
};

const CheckBoxWrapper = styled.div`
    position: relative;
`;
const CheckBoxLabel = styled.label`
    ${({ theme: { colors } }) => `
    position: absolute;
    top: 0;
    left: 0;
    width: 38px;
    height: 24px;
    border-radius: 26px;
        background: ${colors.background.disabled};
        cursor: pointer;
        &::after {
            content: '';
            display: block;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            margin: 2px;
            background: ${colors.brand.main};
            box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
            transition: 0.2s;
        }
    `}
`;
const CheckBox = styled.input`
    ${({ theme: { colors } }) => `   
        opacity: 0;
        z-index: 1;
        border-radius: 26px;
        width: 38px;
        height: 24px;
        margin: 0px;
        &:checked + ${CheckBoxLabel} {
            background: ${colors.primary};
            &::after {
                content: '';
                display: block;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                margin-left: 16px;
                transition: 0.2s;
            }
        }
    `}
`;

export { Switch };
